module.exports = __webpack_public_path__ + "static/media/refreshCircle.70db47c7.svg";